import Api from './Api'

export default {
    get(keyword, pageNumber, order) {
        return Api().get(`image?keyword=${keyword}&pageNumber=${pageNumber}&orderColumn=${order.column}&orderSort=${order.sort}`);
    },
    getOne(id) {
        return Api().get(`image/${id}`);
    },
    create(data) {
        return Api().post(`image`, data);
    },
    update(data) {
        return Api().put(`image/${data.id}`, data);
    }
}